/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';
import styles from './shared-styles';

const DownArrowLong = ({ height, width, color, className, secondaryColor, ...props }) => (
  <span css={styles} className={className}>
    <svg viewBox="0 0 15 18" height={height} width={width} {...props} xmlns="http://www.w3.org/2000/svg">
      <g fill={color}>
        <path d="M12.244 10.448c.63-.564 1.65-.564 2.281 0 .63.567.63 1.481 0 2.047l-5.887 5.084c-.63.566-1.652.566-2.282 0L.469 12.495c-.63-.566-.629-1.483 0-2.046.63-.565 1.65-.565 2.28 0l3.264 2.967V1.5a1.502 1.502 0 1 1 3.005 0v11.882z" />
      </g>
    </svg>
  </span>
);

DownArrowLong.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number,
  color: PropTypes.string,
  className: PropTypes.string,
  secondaryColor: PropTypes.string
};

DownArrowLong.defaultProps = {
  height: 25,
  width: 25,
  color: 'currentColor',
  className: '',
  secondaryColor: 'currentColor'
};

export default DownArrowLong;
